export default __webpack_public_path__ + "static/media/glo.26937ad5.png";